import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

export default function ConfirmFulfill({ open, onCancel, onConfirm, count }) {
  const onClose = (e, reason) => {
    if (reason !== 'backdropClick') {
      onCancel(e)
    }
  };
  return (
    <Dialog
      onClose={onClose}
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="delete-dialog"
      open={open}
    >
      <DialogTitle id="delete-dialog">Confirm</DialogTitle>
      <DialogContent>
        {`${count} orders will be marked as Fulfilled`}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onCancel} color="primary">
          Cancel
        </Button>
        <Button onClick={onConfirm} color="primary">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
